import APIClient from '@/shared/http/clients/api'

const resourceName = 'utilizacao-produtos'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}`, config)
// const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name IAPRepository
 * @description IAP
 * @type { Respository }
 */
const IAPRepository = {
  Search
}

export default IAPRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/iap.js